import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=f4cb1870&scoped=true&"
import script from "./conversation-message.ts?vue&type=script&lang=ts&"
export * from "./conversation-message.ts?vue&type=script&lang=ts&"
import style0 from "./ConversationMessage.vue?vue&type=style&index=0&id=f4cb1870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb1870",
  null
  
)

export default component.exports